import React, { useState } from "react";
import { BASE_URL_API } from "../References/urls";

const AuthContext = React.createContext({
	token: localStorage.getItem("token"),
	isLoggedIn: false,
	userIdentifier: localStorage.getItem("userIdentifier"),
	profilePic: localStorage.getItem("profilePic") || null,
	pendingProfileCompletion:
		sessionStorage.getItem("pendingProfileCompletion") === "1",
	tempUserId: sessionStorage.getItem("tempUserId"),
	login: (token) => {},
	logout: () => {},
	setProfilePic: (pic) => {},
	setPendingProfileCompletion: (userId) => {},
	clearPendingProfileCompletion: () => {},
});

export const AuthContextProvider = (props) => {
	const [token, setToken] = useState(localStorage.getItem("token"));
	const [userIdentifier, setUserIdentifier] = useState(
		localStorage.getItem("userIdentifier")
	);
	const [profilePic, setProfilePicState] = useState(
		localStorage.getItem("profilePic") || null
	);
	const [pendingProfileCompletion, setPendingProfileCompletionState] =
		useState(sessionStorage.getItem("pendingProfileCompletion") === "1");
	const [tempUserId, setTempUserIdState] = useState(
		sessionStorage.getItem("tempUserId")
	);
	// const [userIsLoggedIn, setUserIsLoggedIn] = useState(token ? true : false);

	const userIsLoggedIn = !!token;

	const getUserProfileData = async (token, userIdentifier) => {
		try {
			const response = await fetch(BASE_URL_API + "/getUserProfileData", {
				method: "POST",
				body: JSON.stringify({
					token: token,
					userIdentifier: userIdentifier,
				}),
			});

			if (!response.ok) {
				console.error("Failed to load profile data.");
			} else {
				const respo = await response.json();
				if (respo.status === "success") {
					const userData = respo.response;
                    if (userData.profilePic) {
                        setProfilePicHandler(userData.profilePic);
                    }
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const loginHandler = (token, userIdentifier) => {
		localStorage.setItem("token", token);
		localStorage.setItem("userIdentifier", userIdentifier);
		// setUserIsLoggedIn(true);
		setToken(token);
		setUserIdentifier(userIdentifier);
        getUserProfileData(token, userIdentifier);
	};

	const setPendingProfileCompletionHandler = (userId) => {
		sessionStorage.setItem("pendingProfileCompletion", "1");
		sessionStorage.setItem("tempUserId", userId);
		setPendingProfileCompletionState(true);
		setTempUserIdState(userId);
	};

	const clearPendingProfileCompletionHandler = () => {
		sessionStorage.removeItem("pendingProfileCompletion");
		sessionStorage.removeItem("tempUserId");
		setPendingProfileCompletionState(false);
		setTempUserIdState(null);
	};

	const logoutHandler = () => {
		setToken(null);
		setUserIdentifier(null);
		setProfilePicState(null);
		setPendingProfileCompletionState(false);
		setTempUserIdState(null);
		// setUserIsLoggedIn(false);
		localStorage.removeItem("token");
		localStorage.removeItem("userIdentifier");
		localStorage.removeItem("profilePic");
		localStorage.removeItem("postLoginRedirect");
		localStorage.removeItem("postLoginRedirectSetAt");
		sessionStorage.removeItem("pendingProfileCompletion");
		sessionStorage.removeItem("tempUserId");
	};

	const setProfilePicHandler = (pic) => {
    if (pic && pic.trim() !== "") {
        localStorage.setItem("profilePic", pic);
        setProfilePicState(pic);
    } else {
        localStorage.removeItem("profilePic");
        setProfilePicState(null);
    }
    };


	const contextValue = {
		token: token,
		isLoggedIn: userIsLoggedIn,
		userIdentifier: userIdentifier,
		profilePic: profilePic,
		pendingProfileCompletion,
		tempUserId,
		login: loginHandler,
		logout: logoutHandler,
		setProfilePic: setProfilePicHandler,
		setPendingProfileCompletion: setPendingProfileCompletionHandler,
		clearPendingProfileCompletion: clearPendingProfileCompletionHandler,
	};

	return (
		<AuthContext.Provider value={contextValue}>
			{props.children}
		</AuthContext.Provider>
	);
};

export default AuthContext;
